import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1710ee86"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex flex-col gap-4",
  "data-testid": "document-review-panel"
}
const _hoisted_2 = {
  key: 0,
  class: "h-[420px] rounded-lg bg-gray-100 animate-pulse",
  "data-testid": "document-review-panel-skeleton"
}
const _hoisted_3 = {
  key: 1,
  class: "grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_320px] gap-5 w-full text-left"
}
const _hoisted_4 = { class: "flex flex-col gap-4" }
const _hoisted_5 = { class: "flex flex-col gap-1" }
const _hoisted_6 = { class: "text-base font-bold text-textPrimary" }
const _hoisted_7 = {
  key: 0,
  class: "text-xs text-[#52526f]"
}
const _hoisted_8 = {
  key: 1,
  class: "text-xs font-semibold text-[#52526f]",
  "data-testid": "document-review-imported"
}
const _hoisted_9 = { class: "grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 text-[12px]" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "text-[#7f7f8e]" }, "Enviado em", -1))
const _hoisted_11 = { class: "text-textPrimary" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "text-[#7f7f8e]" }, "Na fila", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "text-[#7f7f8e]" }, "Validade", -1))
const _hoisted_14 = { class: "text-textPrimary" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "text-[#7f7f8e]" }, "Cód. autenticidade", -1))
const _hoisted_16 = { class: "text-textPrimary" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "text-[#7f7f8e]" }, "Verificação", -1))
const _hoisted_18 = {
  key: 0,
  class: "rounded-lg bg-red-50 border border-red-200 p-2.5 text-[12px] text-textPrimary"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Orientação enviada ao médico:", -1))
const _hoisted_20 = {
  key: 1,
  class: "rounded-lg bg-[#f0f0f4] p-2.5 text-[12px] text-[#52526f]"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "text-textPrimary" }, "Como conferir:", -1))
const _hoisted_22 = {
  key: 2,
  class: "flex flex-col gap-2"
}
const _hoisted_23 = {
  key: 0,
  class: "text-[11px] text-[#7f7f8e] text-center"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", { class: "kbd" }, "A", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", { class: "kbd" }, "R", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", { class: "kbd" }, "J", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", { class: "kbd" }, "K", -1))
const _hoisted_28 = {
  key: 3,
  class: "flex flex-col gap-1"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-[11px] text-[#7f7f8e] text-center" }, "Volta o documento para Em Análise.", -1))
const _hoisted_30 = {
  key: 4,
  class: "text-[12px] text-[#7f7f8e]"
}

import { computed } from 'vue'
import { mdiCheck, mdiClose, mdiUndoVariant } from '@mdi/js'

import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import GhostButton from '@/components/designSystem/Buttons/GhostButton/index.vue'
import DocumentHistory from '@/components/ProfessionalDocuments/DocumentHistory.vue'
import DocumentStatusBadge from '@/components/ProfessionalDocuments/DocumentStatusBadge.vue'
import DocumentViewer from '@/components/ProfessionalDocuments/DocumentViewer.vue'
import { formatDateTime, formatIsoDate } from '@/components/ProfessionalDocuments/labels'
import {
  ProfessionalDocumentStatus,
  ProfessionalDocumentVerification,
  ProfessionalDocumentVersionSource
} from '@/types/professional-documents.types'
import type { ProfessionalDocumentsDetailResponse } from '@/types/professional-documents.types'

import type { ReviewQueueEntry } from '../model'
import WaitingSince from './WaitingSince.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentReviewPanel',
  props: {
    entry: {},
    detail: {},
    isLoadingDetail: { type: Boolean },
    showShortcuts: { type: Boolean }
  },
  emits: ["approve", "reject", "undo"],
  setup(__props: any, { emit }) {

const props = __props;




const document = computed(
  () =>
    props.detail?.documents.find((item) => item.documentId === props.entry.document.documentId) ??
    null
)

/** O detalhe é mais novo que a fila (recarrega depois de cada decisão): ele manda quando existe. */
const status = computed(() => document.value?.status ?? props.entry.document.status)
const isLegacy = computed(() => document.value?.isLegacy ?? props.entry.document.isLegacy)
const isInReview = computed(() => status.value === ProfessionalDocumentStatus.IN_REVIEW)

/** Documento sem compartilhamento com a empresa de quem vê (D80, R14): sem abrir nem decidir. */
const isRestricted = computed(
  () => document.value !== null && document.value.currentVersion === null
)

/** Sem o detalhe ainda, a versão da fila já basta para abrir o arquivo. */
const viewerVersionId = computed(() =>
  document.value
    ? (document.value.currentVersion?.versionId ?? null)
    : props.entry.document.currentVersionId
)

/**
 * Legado sem arquivo (D11) nunca desfaz; versão importada (BACKFILL, A5) desfaz como as
 * demais — o backend diz qual versão é desfazível em `undoableVersionId`.
 */
const undoVersionId = computed(() =>
  isLegacy.value || isRestricted.value ? null : (document.value?.undoableVersionId ?? null)
)

function undo() {
  if (undoVersionId.value !== null) emit('undo', undoVersionId.value)
}

/** CRM na base só para tipos com conferência na fonte, e só se a base respondeu (`null` = sem consulta). */
const showCrmCheck = computed(
  () =>
    document.value !== null &&
    document.value.verification !== ProfessionalDocumentVerification.MANUAL &&
    props.detail?.crmActive != null
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.isLoadingDetail && !document.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(DocumentViewer, {
            "version-id": viewerVersionId.value,
            "is-legacy": isLegacy.value,
            "is-restricted": isRestricted.value,
            "page-count": document.value?.currentVersion?.pageCount ?? null,
            "size-bytes": document.value?.currentVersion?.sizeBytes ?? null
          }, null, 8, ["version-id", "is-legacy", "is-restricted", "page-count", "size-bytes"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.entry.document.name), 1),
              (document.value?.currentVersion)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, " versão " + _toDisplayString(document.value.currentVersion.versionNumber), 1))
                : _createCommentVNode("", true),
              (document.value?.currentVersion?.source === _unref(ProfessionalDocumentVersionSource).BACKFILL)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Importado da base da operação "))
                : _createCommentVNode("", true),
              _createVNode(DocumentStatusBadge, {
                status: status.value,
                "pending-reason": document.value?.pendingReason ?? _ctx.entry.document.pendingReason,
                rejection: document.value?.rejection ?? null,
                "expires-at": document.value?.expiresAt ?? null,
                "is-legacy": isLegacy.value
              }, null, 8, ["status", "pending-reason", "rejection", "expires-at", "is-legacy"])
            ]),
            _createElementVNode("dl", _hoisted_9, [
              (_ctx.entry.document.submittedAt)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_10,
                    _createElementVNode("dd", _hoisted_11, _toDisplayString(_unref(formatDateTime)(_ctx.entry.document.submittedAt)), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (isInReview.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_12,
                    _createElementVNode("dd", null, [
                      _createVNode(WaitingSince, {
                        since: _ctx.entry.document.submittedAt
                      }, null, 8, ["since"])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (document.value?.expiresAt)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _hoisted_13,
                    _createElementVNode("dd", _hoisted_14, _toDisplayString(_unref(formatIsoDate)(document.value.expiresAt)), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (document.value?.authenticityCode)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _hoisted_15,
                    _createElementVNode("dd", _hoisted_16, _toDisplayString(document.value.authenticityCode), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (showCrmCheck.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _hoisted_17,
                    _createElementVNode("dd", {
                      class: _normalizeClass(_ctx.detail?.crmActive ? 'text-sucess' : 'text-negative')
                    }, " CRM " + _toDisplayString(_ctx.detail?.crmActive ? 'Ativo' : 'não ativo') + " na base ", 3)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            (document.value?.rejection?.guidance)
              ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                  _hoisted_19,
                  _createTextVNode(" " + _toDisplayString(document.value.rejection.guidance), 1)
                ]))
              : _createCommentVNode("", true),
            (document.value?.description)
              ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                  _hoisted_21,
                  _createTextVNode(" " + _toDisplayString(document.value.description), 1)
                ]))
              : _createCommentVNode("", true),
            (isInReview.value && !isRestricted.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(FilledButton, {
                    text: "Aprovar",
                    width: "100%",
                    height: "44px",
                    "prepend-icon": _unref(mdiCheck),
                    "data-testid": "document-review-approve",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('approve')))
                  }, null, 8, ["prepend-icon"]),
                  _createVNode(OutlineButton, {
                    text: "Reprovar",
                    width: "100%",
                    height: "44px",
                    "prepend-icon": _unref(mdiClose),
                    "data-testid": "document-review-reject",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('reject')))
                  }, null, 8, ["prepend-icon"]),
                  (_ctx.showShortcuts)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                        _createTextVNode(" Atalhos: "),
                        _hoisted_24,
                        _createTextVNode(" aprovar · "),
                        _hoisted_25,
                        _createTextVNode(" reprovar · "),
                        _hoisted_26,
                        _createTextVNode("/"),
                        _hoisted_27,
                        _createTextVNode(" próximo/anterior ")
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (undoVersionId.value !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createVNode(GhostButton, {
                      text: "Desfazer decisão",
                      width: "100%",
                      height: "40px",
                      "prepend-icon": _unref(mdiUndoVariant),
                      "data-testid": "document-review-undo",
                      onClick: undo
                    }, null, 8, ["prepend-icon"]),
                    _hoisted_29
                  ]))
                : (status.value === _unref(ProfessionalDocumentStatus).PENDING)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_30, " Aguardando o médico enviar pelo app. "))
                  : _createCommentVNode("", true),
            _createVNode(DocumentHistory, {
              events: document.value?.history ?? []
            }, null, 8, ["events"])
          ])
        ]))
  ]))
}
}

})